module.exports = __webpack_public_path__ + "static/media/fill_58.d80ebbda.svg";